import React, { useState, useRef, useEffect } from "react";
import styles from "../../_css/ContenetManagement.module.css";
import { ChevronDown } from "lucide-react";
import DataLoader from "./DataLoader.js"; 

const CustomDropdown = ({ value, options, onChange, label, disabled, isLoading }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleOptionClick = (optionValue) => {
        onChange(optionValue);
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const selectedOption = options?.find(option => option.value === value);

    return (
        <div className={styles.tutorialModal__dropdown} ref={dropdownRef}>
            <div
                className={styles.tutorialModal__dropdownTrigger}
                // Only toggle if not disabled
                onClick={() => !disabled && setIsOpen(!isOpen)}
                style={{
                    opacity: disabled ? 0.6 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    pointerEvents: disabled ? 'none' : 'auto',
                    backgroundColor: disabled ? '#f8f9fa' : 'white'
                }}
            >
                <span className={styles.tutorialModal__selectedValue}>
                    {selectedOption ? selectedOption.label : label}
                </span>
                <ChevronDown
                    size={20}
                    className={`${styles.tutorialModal__dropdownIcon} ${isOpen ? styles.tutorialModal__dropdownIconOpen : ''}`}
                />
            </div>

            {isOpen && !disabled && (
                <div className={styles.tutorialModal__dropdownMenu}>
                    {isLoading ? (
                        /* Show DataLoader when loading */
                        <div style={{ padding: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <DataLoader />
                        </div>
                    ) : (
                        /* Show Options or No Data message */
                        options && options.length > 0 ? (
                            options.map((option) => (
                                <button
                                    key={option.value}
                                    className={`${styles.tutorialModal__dropdownOption} ${value === option.value ? styles.tutorialModal__dropdownOptionActive : ''}`}
                                    onClick={() => handleOptionClick(option.value)}
                                >
                                    {option.label}
                                </button>
                            ))
                        ) : (
                            <div
                                className={styles.tutorialModal__dropdownOption}
                                style={{ cursor: 'default', color: '#999', fontStyle: 'italic', textAlign: 'center' }}
                            >
                                No data available
                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;